<template>
  <div class="content">
    <div class="content-box factry-info">
      <el-form :model="form" ref="form" label-width="150px" label-position="top">
        <div class="form-box">
          <p class="form-title">
            {{ $t('crm_factory_item_info.gong_si_xin_xi') }}
          </p>
          <el-row class="form-container">
            <el-col :span="12" class="form-container-left">
              <el-form-item :label="$t('crm_factory_item_info.gong_si_ming_cheng')" prop="partnerName" :rules="rules.partnerName">
                <el-input v-model="form.partnerName" style="width: 414px"></el-input>
              </el-form-item>
              <el-form-item :label="$t('crm_factory_item_info.tyshxydmyyzzbh')" prop="businessLicense" :rules="erpCodeRequired ? [] : rules.businessLicense">
                <el-input v-model.trim="form.businessLicense" :disabled="!!partnerId && !propsFuncView.partner_factory_license" style="width: 414px"></el-input>
              </el-form-item>
              <el-form-item :label="$t('crm_factory_item_info.nsrsbhswdjbh')" prop="buyerNumber" :rules="rules.buyerNumber">
                <el-input v-model.trim="form.buyerNumber" style="width: 414px"></el-input>
              </el-form-item>

              <el-form-item :label="$t('crm_factory_item_info.gong_si_di_zhi')" prop="address" :rules="rules.address">
                <custom-address-select :placeholder="$t('Common.com_please_select')" v-model="form.address" ref="address" style="width: 414px"></custom-address-select>
              </el-form-item>
              <el-form-item :label="$t('crm_factory_item_info.gsxxdz')" prop="detailAddress" :rules="rules.detailAddress">
                <el-input type="textarea" v-model="form.detailAddress" style="width: 414px"></el-input>
              </el-form-item>
              <el-form-item :label="$t('crm_factory_item_info.gong_si_bian_hao')" prop="partnerCode" :rules="erpCodeRequired ? [] : rules.partnerCode">
                <el-input v-model="form.partnerCode" style="width: 414px"></el-input>
              </el-form-item>
              <el-form-item :label="$t('crm_factory_item_info.gong_si_wang_zhi')" prop="website" :rules="rules.website">
                <el-input v-model="form.website" style="width: 414px"></el-input>
              </el-form-item>
              <el-form-item :label="$t('crm_factory_item_info.gong_si_miao_shu')" prop="partnerDesc" :rules="rules.partnerDesc">
                <el-input type="textarea" v-model="form.partnerDesc" style="width: 414px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="form-container-right">
              <el-form-item :label="$t('crm_factory_item_info.yyzzocrsb')" prop="imageLicense" :rules="rules.imageLicense" style="position: relative">
                <span slot="label">
                  {{ $t('crm_factory_item_info.ying_ye_zhi_zhao') }}
                  <i
                    v-if="!partnerId && propsFuncView.partner_factory_ocr"
                    style="position: absolute; right: 0px; color: #0d9ae0; text-decoration: underline; font-size: 12px; cursor: pointer"
                    @click="
                      onOCR('license', {
                        partnerName: 'name',
                        businessLicense: 'regCode',
                        buyerNumber: 'regCode',
                        legalPerson: 'legalPerson',
                        detailAddress: 'address',
                      })
                    "
                  >
                    {{ $t('crm_factory_item_info.OCRshi_bie_nei_rong') }}
                  </i>
                </span>
                <file-upload
                  :text="$t('crm_factory_item_info.scyyzz')"
                  :contentStyle="{
                    width: '100%',
                    height: '200px',
                    'padding-top': '79px',
                    background: '#F5F5F5',
                  }"
                  v-model="imageLicense"
                  ref="license"
                  bizType="crm.partner.license"
                  :autoUpload="false"
                  :bizId="factoryId"
                  @effect="checkOcr"
                  :tips="$t('crm_factory_item_info.qsccsyjhjggsqdxbcg2M')"
                ></file-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="tip">
            <i class="icon icon-tishi"></i>
            <span>{{ $t('crm_factory_item_info.qhdysxxyyyzzxxyz') }}</span>
          </div>
          <el-row class="form-container">
            <el-col :span="12" class="form-container-left">
              <el-form-item :label="$t('crm_factory_item_info.gong_si_lei_xing')" prop="partnerType" :rules="rules.partnerType">
                <custom-select :placeholder="$t('Common.com_please_select')" v-model="form.partnerType" code="bas_org_type" width="414px" :disabled="true"></custom-select>
              </el-form-item>

              <el-form-item :label="$t('crm_factory_item_info.gong_si_dian_hua')" prop="telephone" :rules="rules.telephone">
                <el-input v-model="form.telephone" style="width: 414px"></el-input>
              </el-form-item>
              <el-row :gutter="8">
                <el-col :span="18">
                  <el-form-item :label="$t('crm_factory_item_info.zhu_ce_zi_jin')" prop="registeredCapital" :rules="rules.registeredCapital">
                    <el-input type="number" :min="0" v-model.number="form.registeredCapital" style="width: 100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('crm_factory_item_info.zi_jin_lei_xing')" prop="currencyUnit" :rules="rules.currencyUnit">
                    <custom-select :placeholder="$t('Common.com_please_select')" v-model="form.currencyUnit" code="isynergy_cloud_currency" width="100%"></custom-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item :label="$t('crm_factory_item_info.ying_zhi')" prop="nonMetric" :rules="rules.nonMetric">
                <el-switch v-model="form.nonMetric" :active-value="1" :inactive-value="0"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="form-container-right">
              <el-form-item :label="$t('crm_factory_item_info.gong_si_gui_mo')" prop="partnerScale" :rules="rules.partnerScale">
                <custom-select :placeholder="$t('Common.com_please_select')" v-model="form.partnerScale" code="crm_partner_scale" width="414px"></custom-select>
              </el-form-item>
              <el-form-item :label="$t('crm_factory_item_info.shi_qu')" prop="timeZoneId" :rules="rules.timeZoneId" v-if="this.timeZoneList.length > 1">
                <custom-select v-model="form.timeZoneId" :data="timeZoneList" :auto="false" :props="{ label: 'timeZoneRegionDesc', value: 'timeZoneId' }" width="414px"></custom-select>
              </el-form-item>
              <el-form-item :label="$t('crm_factory_item_info.bbscsjpylh')" prop="reportOffset" :rules="rules.reportOffset">
                <el-input type="number" v-model.number="form.reportOffset" width="414px"></el-input>
              </el-form-item>
              <el-form-item :label="$t('crm_factory_item_info.gong_si_you_xiang')" prop="email" :rules="rules.email">
                <el-input v-model="form.email" style="width: 414px"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="form-box">
          <p class="form-title">
            {{ $t('crm_factory_item_info.fa_ren_xin_xi') }}
          </p>
          <el-row class="form-container">
            <el-col :span="12" class="form-container-left">
              <el-form-item :label="$t('crm_factory_item_info.fa_ren_xing_ming')" prop="legalPerson" :rules="rules.legalPerson">
                <el-input v-model="form.legalPerson" style="width: 414px"></el-input>
              </el-form-item>
              <el-form-item :label="$t('crm_factory_item_info.frsfzhm')" prop="legalPersonIdentity">
                <el-input v-model="form.legalPersonIdentity" style="width: 414px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="form-container-right">
              <el-form-item :label="$t('crm_factory_item_info.frsfz')" prop="imageIdFace">
                <el-row>
                  <file-upload
                    :text="$t('crm_factory_item_info.sfzrxm')"
                    :contentStyle="{
                      width: '200px',
                      height: '120px',
                      'padding-top': '37px',
                      background: '#F5F5F5',
                      float: 'left',
                    }"
                    v-model="imageIdFace"
                    ref="imageIdFace"
                    bizType="crm.id.face"
                    :autoUpload="false"
                    :bizId="factoryId"
                  ></file-upload>
                  <file-upload
                    :text="$t('crm_factory_item_info.sfzghm')"
                    :contentStyle="{
                      width: '200px',
                      height: '120px',
                      'padding-top': '37px',
                      background: '#F5F5F5',
                      float: 'right',
                    }"
                    v-model="imageIdReverse"
                    ref="imageIdReverse"
                    bizType="crm.id.reverse"
                    :autoUpload="false"
                    :bizId="factoryId"
                  ></file-upload>
                </el-row>
                <div class="tips mt-6">
                  {{ $t('page_content_idUploadTips') }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="tip" style="margin-bottom: 0">
            <i class="icon icon-tishi"></i>
            <span>{{ $t('crm_factory_item_info.qhdysxxyyyzzsfzxxyz') }}</span>
          </div>
        </div>
        <div class="form-box">
          <p class="form-title">
            {{ $t('crm_factory_item_info.dgzhxx') }}
          </p>
          <el-row class="form-container">
            <el-col :span="12" class="form-container-left">
              <el-form-item :label="$t('crm_factory_item_info.kai_hu_yin_hang')" prop="depositBank">
                <el-input v-model="form.depositBank" style="width: 414px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="form-container-right">
              <el-form-item :label="$t('crm_factory_item_info.dui_gong_zhang_hao')" prop="depositNumber">
                <el-input v-model="form.depositNumber" style="width: 414px"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <div class="btn-group">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveInfo">{{ $t('crm_factory_item_info.xybszfwqy') }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import customAddressSelect from '@/components/customAddressSelect.vue';
import fileUpload from '@/components/singleFileUpload.vue';

export default {
  name: 'factoryIteminfo',
  components: { fileUpload, customAddressSelect },
  props: {
    partnerId: [String, Number],
    propsFuncView: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    // 密码验证
    return {
      cascaderProps: {
        value: 'code',
        label: 'value',
      },
      // 营业执照
      imageLicense: [],
      // 身份证id正面
      imageIdFace: [],
      // 身份证反面
      imageIdReverse: [],
      form: {
        partnerName: '',
        partnerClass: '1',
        partnerCode: '',
        telephone: '',
        email: '',
        partnerScale: '',
        address: '', // 自用不参与交互
        detailAddress: '',
        website: '',
        registeredCapital: '',
        currencyUnit: '¥',
        legalPerson: '',
        legalPersonIdentity: '',
        partnerDesc: '',
        timeZoneId: '', // 总部时区
        reportOffset: '', // 报表生成时间偏移量
        partnerType: 'HQ', // 总部 HQ 售后公司SC 总代理 JV 大客户CO 公司CS
        enterpriseType: '1', // 1-企业，2-个体工商户，3-事业单位，4-宗教活动场所，5-其他 售后公司只能是企业1
        nonMetric: '0',
        // 地址
        country: '',
        countryCode: '',
        province: '',
        provinceCode: '',
        city: '',
        cityCode: '',

        // 营业执照
        businessLicense: '',
        // 纳税人识别号
        buyerNumber: '',
        // 修改的
        extendId: '',

        imageLicense: false,
        imageIdFace: false,
        imageIdReverse: false,
        // 对公信息
        depositBank: '',
        depositNumber: '',
        // bankCode: '',
        // bankName: '',
        bankcardId: '', // 银行信息  id  编辑 用
      },
      timeZoneList: [],
      // 公司ID
      factoryId: '',
      // ERP编号权限
      erpCodeRequired: false,
    };
  },
  watch: {
    partnerId(val) {
      this.factoryId = val || '';
      this.getCompanyDetail();
    },
  },
  computed: {
    rules() {
      return {
        // 基本信息
        partnerName: [
          {
            type: 'string',
            required: true,
            message: this.$t('crm_factory_item_info.qtxgsmc'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ],
        partnerType: { required: true },
        timeZoneId: [
          {
            required: true,
            message: this.$t('crm_factory_item_info.qing_xuan_ze_shi_qu'),
          },
        ],
        reportOffset: [
          {
            required: true,
            message: this.$t('crm_factory_item_info.qtxbbscsjpyl'),
          },
          {
            type: 'number',
            min: -12,
            max: 12,
            message: this.$t('crm_factory_item_info.sjpylyz12h12fwn'),
          },
        ],
        partnerCode: [
          {
            type: 'string',
            required: true,
            message: this.$t('crm_factory_item_info.qtxgsbh'),
          },
          { max: 20, message: this.$t('Common.com_rules_length_max', [20]) },
        ],
        telephone: [
          {
            type: 'string',
            required: true,
            message: this.$t('crm_factory_item_info.qtxgsdh'),
          },
          {
            validator: null,
            message: this.$t('crm_factory_item_info.cdyz713gzf'),
          },
        ],
        email: [
          {
            type: 'email',
            required: true,
            message: this.$t('crm_factory_item_info.qtxgsyx'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ],
        partnerScale: {
          required: true,
          message: this.$t('crm_factory_item_info.qxzgsgm'),
        },
        businessLicense: [
          {
            required: true,
            message: this.$t('crm_factory_item_info.qtxtyshxydmyyzzbh'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ],
        buyerNumber: [
          {
            required: true,
            message: this.$t('crm_factory_item_info.qtxnsrsbhswdjbh'),
          },
          {
            min: 6,
            max: 50,
            message: this.$t('crm_factory_item_info.cdyz650gzf'),
          },
        ],
        address: [
          {
            required: true,
            type: 'array',
            message: this.$t('crm_factory_item_info.qxzgsdz'),
          },
        ],
        detailAddress: [
          {
            type: 'string',
            required: true,
            message: this.$t('crm_factory_item_info.qtxgsxxdz'),
          },
          { max: 100, message: this.$t('Common.com_rules_length_max', [100]) },
        ],

        website: { max: 100, message: this.$t('Common.com_rules_length_max', [100]) },
        registeredCapital: {
          type: 'number',
          min: 0,
          message: this.$t('crm_factory_item_info.zczjbnxy0'),
        },
        legalPerson: [
          {
            required: true,
            message: this.$t('crm_factory_item_info.qtxfrxm'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ],
        legalPersonIdentity: [
          {
            required: true,
            message: this.$t('crm_factory_item_info.qtxfrsfzhm'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ], // 数字或字母
        partnerDesc: { max: 200, message: this.$t('Common.com_rules_length_max', [200]) },
        imageLicense: {
          type: 'string',
          required: true,
          message: this.$t('crm_factory_item_info.qscyyzz'),
        },
        imageIdFace: {
          type: 'string',
          required: true,
          message: this.$t('crm_factory_item_info.qscsfzzfm'),
        },
        imageIdReverse: {
          type: 'string',
          required: true,
          message: this.$t('crm_factory_item_info.qscsfzghm'),
        },
        depositBank: {
          type: 'string',
          required: true,
          message: this.$t('crm_factory_item_info.qtxkhyh'),
        },
        depositNumber: {
          type: 'string',
          required: true,
          message: this.$t('crm_factory_item_info.qtxdgzh'),
        },
      };
    },
  },
  mounted() {
    // this.factoryId = this.getJump('factoryId');
    this.factoryId = this.partnerId || '';
    // ocr识别权限全在总部上管理
    // this.getFuncView('/distributor/factory');
    this.rules.registeredCapital.validator = (rule, value, callback) => {
      if (value && !(/(^[1-9]\d*$)/).test(value)) {
        callback(new Error());
      } else {
        callback();
      }
    };
    this.rules.telephone[1].validator = this.$mobilePhoneValidator;
    this.getCompanyDetail();
    // 查字典
    this.getDictionary('cloud_erpCode_control', () => {
      this.erpCodeRequired = this.$searchSiteCodeFunction('cloud_erpCode_control');
    });
  },
  methods: {
    getCompanyDetail: function () {
      if (!this.factoryId) {
        this.getTimeZoneList(true);
        return;
      }
      this.$getJSON(apis.partnerInfo, { partnerId: this.factoryId }).then((res) => {
        if (res.code === 0) {
          const data = res.data;
          this.$setFormatData(this.form, data);
          this.form.address = [];
          if (data.countryCode) {
            this.form.address.push(data.countryCode);
          }
          if (data.provinceCode) {
            this.form.address.push(data.provinceCode);
          }
          if (data.cityCode) {
            this.form.address.push(data.cityCode);
          }
          this.form.partnerClass = `${data.partnerClass}`;
          this.form.currencyUnit = `${data.currencyUnit}`;
          // this.form.timeZone = `${data.timeZone}`;
          this.form.partnerType = data.partnerType;
          // 数字转字符串
          this.form.registeredCapital = +data.registeredCapital;
          // 营业执照
          this.businessLicenseImageList = this.businessLicenseImageList || [];
          this.idImageList = this.idImageList || [];
          this.getTimeZoneList(false);
        }
      });
    },
    // 获取时区列表
    getTimeZoneList: function (isInit) {
      this.$getJSON(apis.timeZoneGetCompanyList).then((res) => {
        this.timeZoneList = res.data;
        // 新建时 一个或多个都要默认选择第一个  编辑不用管
        if (this.timeZoneList.length > 0 && isInit) {
          this.form.timeZoneId = this.timeZoneList[0].timeZoneId;
        }
      });
    },
    // 图片校验
    checkImg() {
      if (this.imageLicense.length > 0) {
        this.form.imageLicense = 'imageLicense';
      } else {
        this.form.imageLicense = null;
      }
      if (this.imageIdFace.length > 0) {
        this.form.imageIdFace = 'imageIdFace';
      } else {
        this.form.imageIdFace = '';
      }
      if (this.imageIdReverse.length > 0) {
        this.form.imageIdReverse = 'imageIdReverse';
      } else {
        this.form.imageIdReverse = '';
      }
    },

    // ocr校验
    checkOcr() {
      this.checkImg();
    },
    onOCR(refName, keyMap) {
      this.$refs[refName].ocr().then((data) => {
        Object.keys(keyMap).forEach((key) => {
          this.form[key] = data[keyMap[key]];
        });
      });
    },
    // 取消
    onCancel: function () {
      this.jump('/distributor/factory', { refresh: true }, true);
    },
    // onBankCode: function (item) {
    //   if (item) {
    //     this.form.bankName = item.bankName || '';
    //   } else {
    //     this.form.bankName = '';
    //   }
    // },
    // 保存基本信息
    saveInfo: async function () {
      await Promise.all([this.$refs.license.submit(), this.$refs.imageIdFace.submit(), this.$refs.imageIdReverse.submit()]);
      this.checkImg();
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        // 赋值 国家城市镇区
        const addressMsg = this.$refs.address.getAddressMsg();
        this.$setFormatData(this.form, addressMsg);

        // 图片保存
        this.form.partnerInstructionList = [...this.imageLicense, ...this.imageIdFace, ...this.imageIdReverse];
        // 保存交互
        if (this.factoryId) {
          // factoryId 公司id  编辑要放进参数里面
          this.form.partnerId = this.factoryId;
          this.$postJSON(apis.partnerUpdate, this.form).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_modify_success'),
                type: 'success',
              });
              this.$emit('success', 2);
              // this.jump('/distributor/serviceCompany', { refresh: true }, true);
            }
          });
        } else {
          //
          this.$postJSON(apis.partnerAdd, this.form).then((res) => {
            this.$emit('syncPartnerId', res.data.partnerId, res.data.partnerOrgId);
            this.$emit('success', 2);
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import '../../../../style/colors.scss';
.factry-info {
  padding: 14px 24px 0;
  .form-box {
    margin-top: 35px;
    position: relative;
    width: 100%;
    border: 1px solid rgba(13, 154, 224, 0.3);
    padding: 34px 24px 24px;
    .form-container {
      width: 900px;
      display: flex;
      .form-container-left {
        width: 414px !important;
        margin-right: 24px;
      }
      .form-container-right {
        width: 414px !important;
        flex: 0 0 414px;
      }
    }
    .form-title {
      font-size: 12px;
      font-weight: 600;
      color: rgba(13, 154, 224, 1);
      line-height: 20px;
      height: 20px;
      position: absolute;
      top: -10px;
      left: 16px;
      background: #ffffff;
      padding: 0 10px;
    }
    .tip {
      background: rgba(53, 184, 224, 0.15);
      border-radius: 2px;
      margin: 8px 0 24px;
      padding-left: 10px;
      .icon {
        color: #0d9ae0;
        font-size: 12px;
        margin-right: 10px;
      }
      span {
        line-height: 32px;
        color: #6c757d;
        font-size: 12px;
      }
    }

    .tips {
      color: #aeb5bd;
      font-size: 12px;
      line-height: 16px;
      margin-top: 6px;
    }
  }
}
</style>
